var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-root"},[_c('chat-panel',{attrs:{"fullscreen":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }